module.exports = __webpack_public_path__ + "static/media/share-active.deff6ee0.png";